import ChannelsAutocomplete from './components/ChannelsAutocomplete';
import withChannels from './withChannels';

export const ChannelsAutoLoad = withChannels(ChannelsAutocomplete);

export default ChannelsAutoLoad;
